"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSessionStorageCache = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _logger = require("../logger");
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint, @typescript-eslint/no-explicit-any -- musts be any or type is not inherited

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- musts be any or type is not inherited

const logger = _logger.mainLogger.createChild('withSessionStorageCache');
class Storage {
  constructor(schema) {
    (0, _defineProperty2.default)(this, "schema", void 0);
    this.schema = schema;
  }
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  get(key) {
    const valueFromStorage = sessionStorage.getItem(key);
    if (!valueFromStorage) {
      return null;
    }
    const validated = this.schema.safeParse(JSON.parse(valueFromStorage));
    if (!validated.success) {
      logger.error(new Error(`Failed to get the value from session storage by key "${key}" as its value is invalid`), {
        issues: validated.error.format()
      });

      // Clear invalid value
      this.clear(key);
      return null;
    }
    return validated.data;
  }
  clear(key) {
    sessionStorage.removeItem(key);
  }
}
const withSessionStorageCache = (options, functionToBeCached) => {
  const {
    key: keyOrKeyAsFunction,
    schema
  } = options;
  const storage = new Storage(schema);
  async function cached(...parameters) {
    const key = typeof keyOrKeyAsFunction === 'function' ? keyOrKeyAsFunction(...parameters) : keyOrKeyAsFunction;
    const lastArgument = parameters.at(-1);
    const isCachingPaused = lastArgument !== undefined && 'pauseCaching' in lastArgument && lastArgument.pauseCaching === true;
    if (!isCachingPaused) {
      const cachedValue = storage.get(key);
      if (cachedValue !== undefined && cachedValue !== null) {
        return cachedValue;
      }
    }
    const uncachedValue = await Promise.resolve(functionToBeCached(...parameters));
    if (!isCachingPaused && uncachedValue !== null && uncachedValue !== undefined) {
      storage.set(key, uncachedValue);
    }
    return uncachedValue;
  }
  return cached;
};
exports.withSessionStorageCache = withSessionStorageCache;